"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAlert = void 0;
var _Alert = require("./Alert");
// TODO: in v9, move styled() from Alert.jsx to here
var StyledAlert = _Alert.Alert;
exports.StyledAlert = StyledAlert;